import Navbar from "./components/Common/Navbar";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import ContactUs from "./pages/ContactUs";
import Footer from "./components/Common/Footer";
import ServiceAndProduct from "./pages/ServiceAndProduct";
import Automation from "./pages/Automaction";
import It from "./pages/IT";

function App() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />

        {/* Automation */}
        <Route path="/automation" element={<Automation />} />

        {/* ⭐ CORRECT IT PAGE ROUTE */}
        <Route path="/it-solution" element={<It />} />

        <Route path="/about" element={<About />} />
        <Route path="/services-it-solution" element={<ServiceAndProduct />} />
        <Route path="/contactus" element={<ContactUs />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
